import React, { Fragment } from 'react';
import { bool } from 'prop-types';

import Bride from '@assets/images/p-arin.jpg';
import Groom from '@assets/images/p-miftah.jpg';
import Cross from '@assets/images/cruz.jpg';


import { styWrapper } from './styles';

function HelloSection({ isInvitation }) {
	const finalSubtitle = 'Domingo, 08 de Diciembre 2024';

	return (
		<Fragment>
			<div id="fh5co-couple" css={styWrapper}>
				<div className="container">
					<div className="row">
						<div className="col-md-8 col-md-offset-2 text-center fh5co-heading">
							<h2 className="main-font">Save the date</h2>
							<h3 className="sub-title hs">{finalSubtitle}</h3>
							<p className="info">
								Deseamos compartir con ustedes la alegria de unir nuestras vidas, y nos gustaría que nos acompañen.
							</p>
						</div>
					</div>
					<div className="couple-wrap">
						<div className="couple-half">
							<div className="groom">
								<img src={Bride} alt="groom" className="img-responsive" loading="lazy" />
							</div>
							<div className="desc-groom">
								<h3 className="main-font">Waldemar Ramirez</h3>
								<p className="parent-name parent-name__top">
								Max Ramirez<img src={Cross} alt="cruz" className="img-responsive-cruz" loading="lazy" /><br />& Telma Barahona
								</p>
							</div>
						</div>
						<p className="heart text-center">
							<i className="icon-heart2"></i>
						</p>
						<div className="and-love">
							<i>&</i>
						</div>
						<div className="couple-half">
							<div className="bride">
								<img src={Groom} alt="groom" className="img-responsive" loading="lazy" />
							</div>
							<div className="desc-bride">
								<h3 className="main-font">Scarlette Pérez</h3>
								<p className="parent-name">
									Eberardo Pérez <br />& Olivia del Cid
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Fragment>
	);
}

HelloSection.propTypes = {
	isInvitation: bool.isRequired,
};

export default HelloSection;
